import {
  Component,
  OnInit,
  Injector,
  OnDestroy,
  ViewEncapsulation,
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  ReactiveFormsModule,
} from "@angular/forms";

import { Router, ActivatedRoute } from "@angular/router";
const swal = require("sweetalert");
import * as ptLocale from "date-fns/locale/pt";
import { BehaviorSubject } from "rxjs";
LoadingService;
import { CustomValidators } from "ng2-validation";
import { DatepickerOptions } from "ng2-datepicker";

import { List } from "lodash";
import { MultiplasLojasService } from "../../multiplas-lojas.service";
import { Empresa } from "../../../../../models/empresa/empresa";
import { LoadingService } from "../../../../../util/loader.service";

@Component({
  selector: "app-cadastro-empresa",
  templateUrl: "./cadastro-empresa.component.html",
  styleUrls: ["./cadastro-empresa.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CadastroEmpresaComponent implements OnInit {
  valForm: FormGroup;
  buttonType: any;
  public searchTyped = new BehaviorSubject("");
  public searchTypedCidades = new BehaviorSubject("");
  public searchTypedVendedor = new BehaviorSubject("");
  router: Router;
  id: any;
  empresa: Empresa;
  edicao = false;
  segmentos: Array<any>;

  public mask: Array<string | RegExp>;
  public maskIe: Array<string | RegExp>;
  public maskCep: Array<string | RegExp>;
  public maskData: Array<string | RegExp>;
  cortesia = false;
  parametroPagamentoCadastrar = false;
  options: DatepickerOptions = {
    locale: ptLocale,
    displayFormat: "DD/MM/YYYY",
    barTitleIfEmpty: "Clique para selecionar a data",
    placeholder: "Clique para selecionar a data",
  };
  isChecked: boolean = false;
  // Datepicker
  bsValue = new Date();
  bsRangeValue: Date[];
  maxDate = new Date();
  bsConfig = {
    containerClass: "theme-angle",
    dateInputFormat: "DD/MM/YYYY",
  };

  constructor(
    public service: MultiplasLojasService,
    public injector: Injector,
    fb: FormBuilder,
    private route: ActivatedRoute,
    private routerNavigate: Router,
    public loader: LoadingService
  ) {
    // INTANCIA O OBJETO
    this.empresa = new Empresa();

    this.mask = [
      /[0-9]/,
      /\d/,
      ".",
      /\d/,
      /\d/,
      /\d/,
      ".",
      /\d/,
      /\d/,
      /\d/,
      "/",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
    ];
    this.maskCep = [
      /[1-9]/,
      /\d/,
      ".",
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      /\d/,
    ];
    this.maskData = [
      /[1-9]/,
      /\d/,
      "/",
      /\d/,
      /\d/,
      "/",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
    this.maskIe = [
      /[1-9]/,
      /\d/,
      /\d/,
      ".",
      /\d/,
      /\d/,
      /\d/,
      ".",
      /\d/,
      /\d/,
      "-",
      /\d/,
    ];

    // VALIDAÃ‡ÃƒO DO FORM
    this.valForm = fb.group({
      empresaNome: [null, Validators.required],
      empresaNomeFantasia: [null, Validators.required],
      empresaDocumento: [null, Validators.required],
      empresaEmail: [null, Validators.required],
      empresaEstado: [null, Validators.required],
      empresaCidade: [null, Validators.required],
      empresaBairro: [null, Validators.required],
      empresaLogradouro: [null, Validators.required],
      empresaCep: [null, Validators.required],
      empresaNumero: [null, Validators.required],
      empresaResponsavel: [null, Validators.required],
      empresaTelefone: [null, Validators.required],
      empresaSegmento: [null, Validators.required],
      empresaSenha: [null, Validators.required],
      empresaRepetirSenha: [null, Validators.required],
      latitude: [null, null],
      longitude: [null, null],
    });

    this.id = this.route.snapshot.paramMap.get("id");
    if (this.id !== undefined && this.id != null) {
     this.disablePassword();
     
      this.loader.show("body");
      this.service.editar(this.id).subscribe((itens) => {
        this.loader.hide("body");
        this.empresa = itens;
      });
      this.edicao = true;
    } else {
      this.edicao = false;
    }
    this.carregarComboSegmento();
  }

  disablePassword(){
    this.valForm.controls["empresaSenha"].clearValidators();
    this.valForm.controls["empresaSenha"].updateValueAndValidity();
    this.valForm.get('empresaSenha').disable();

    this.valForm.controls["empresaRepetirSenha"].clearValidators();
    this.valForm.controls["empresaRepetirSenha"].updateValueAndValidity();
    this.valForm.get('empresaRepetirSenha').disable();
  }
  carregarComboSegmento() {
    this.service.listSegments("").subscribe((itens) => {
      this.segmentos = itens;
    });
  }

  submitForm($ev, value: any, buttonType: string) {
    $ev.preventDefault();
    // tslint:disable-next-line:forin
    for (const c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }

    if (this.valForm.valid) {
      this.loader.show("body");

      this.empresa.latitude = this.valForm.get("latitude").value;
      this.empresa.longitude = this.valForm.get("longitude").value;

      this.service.cadastrarNovaEmpresa(this.empresa).subscribe((result) => {
        this.loader.hide("body");
        this.callbackSave(result);
      });
    }
  }

  callbackSave(result) {
    debugger;
    if (result.id_empresa > 0) {
      debugger;
      swal("Atenção", "Empresa salvo com sucesso.", "success");
      this.empresa = result;
      this.id = result.id_empresa;

      //  this.valForm.reset();
      //  this.routerNavigate.navigate(["/v1/empresa"]);
    }
  }
  buscarEndereco(): void {
    const value = this.valForm
      .get("empresaCep")
      .value.replace(".", "")
      .replace("-", "");

    if (value.toString().trim().length > 7) {
      this.loader.show("body");
      this.service
        .searchAddress(value.toString().trim())
        .subscribe((result) => {
          this.loader.hide("body");

          const response = result as any;
          if (response.erro == null && !response.erro) {
            this.valForm.controls["empresaCidade"].setValue(result.localidade);
            this.valForm.controls["empresaEstado"].setValue(result.uf);
            this.valForm.controls["empresaBairro"].setValue(result.bairro);
            this.valForm.controls["empresaLogradouro"].setValue(
              result.logradouro
            );
            this.getCoodinates();
          }
        });
    }
  }
  getCoodinates(): void {
    const {
      empresaCidade,
      empresaEstado,
      empresaBairro,
      empresaLogradouro,
      empresaCep,
    } = this.valForm.controls;

    const address = `${empresaLogradouro.value}, ${empresaCidade.value}, ${empresaEstado.value}, ${empresaCep.value}`;

    this.service.reverseGeocode(address).subscribe((result) => {
      if (result.length > 0) {
        this.valForm.controls["latitude"].setValue(result[0].lat);
        this.valForm.controls["longitude"].setValue(result[0].lon);
      }
    });
  }

  ngOnInit() {}
}
